import * as Dtos from '../../dtos/Tmd.dtos';

export const
    setEditModalViewState: IInstitutionItemsPageSetEditModalViewStateActionCreator = (open, collectionInstanceId, name, description) => {
        return {
            type: ACTION_INSTITUTIONITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE,
            open,
            collectionInstanceId,
            name,
            description
        }
    },
    setCreateVersionModalViewState: IInstitutionItemsPageSetCreateVersionModalViewStateActionCreator = (open, institutionItem) => {
        return {
            type: ACTION_INSTITUTIONITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE,
            open,
            institutionItem
        }
    }

export const
    ACTION_INSTITUTIONITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE = "ACTION_INSTITUTIONITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE",
    ACTION_INSTITUTIONITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE = "ACTION_INSTITUTIONITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE"

/* Actions */

export interface IInstitutionItemsPageSetEditModalViewStateAction {
    type: "ACTION_INSTITUTIONITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE",
    open: boolean;
    collectionInstanceId: number;
    name: string;
    description: string;
}

export interface IInstitutionItemsPageSetCreateVersionModalViewStateAction {
    type: "ACTION_INSTITUTIONITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE",
    open: boolean;
    institutionItem: Dtos.InstitutionItem
}

/* Action Creators */

export interface IInstitutionItemsPageSetEditModalViewStateActionCreator {
    (
        open: boolean,
        collectionIntanceId: number,
        name: string,
        description: string
    ): IInstitutionItemsPageSetEditModalViewStateAction;
}

export interface IInstitutionItemsPageSetCreateVersionModalViewStateActionCreator {
    (
        open: boolean,
        institutionItem: Dtos.InstitutionItem
    ): IInstitutionItemsPageSetCreateVersionModalViewStateAction;
}


/* Final Export of actions */
export type InstitutionItemsPageAction =
    IInstitutionItemsPageSetEditModalViewStateAction |
    IInstitutionItemsPageSetCreateVersionModalViewStateAction;
